var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.90908 5.14307H4.09497H0.660442C0.072714 5.14307 -0.22115 4.36247 0.195157 3.90488L3.36644 0.419107C3.87458 -0.139423 4.70107 -0.139423 5.20921 0.419107L6.41528 1.74478L8.38049 3.90488C8.79068 4.36247 8.49681 5.14307 7.90908 5.14307Z",
    fill: "#77868B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableup);
export default __webpack_public_path__ + "static/media/tableup.5d12f42e6f9724fac20d513373406ef4.svg";
export { ForwardRef as ReactComponent };